/**
 * lib/bootPct.ts — palier de boot partagé entre un rechargement dur et la
 * page qui suit.
 *
 * sessionStorage est invisible au serveur : la page qui suit un HardRedirect
 * rend forcément 6 % en SSR (premier paint, avant même que le JS charge),
 * puis corrige côté client au montage — chute visible le temps de
 * l'hydratation, `useLayoutEffect` n'y change rien puisqu'il ne peut pas
 * changer ce que le SERVEUR a déjà rendu. Régression signalée deux fois le
 * 30/07 malgré les tentatives sessionStorage puis useLayoutEffect.
 *
 * Un cookie, lui, est lu par le serveur (app/layout.tsx via next/headers)
 * ET par le client (document.cookie) : la page suivante peut rendre le bon
 * palier dès le SSR, premier paint inclus, sans détour ni correction après
 * coup — voir AppShellProps.initialPct.
 */

const KEY = 'ogryn_boot_pct';

export function markBootPct(pct: number) {
  try { document.cookie = `${KEY}=${pct}; path=/; max-age=60; samesite=lax`; } catch {}
}

// Ne consomme pas : le BootScreen de la page de destination en a besoin à
// son propre montage (AppShell a déjà sa valeur via le cookie lu côté serveur).
export function peekBootPct(): number {
  try {
    const m = document.cookie.match(new RegExp(`(?:^|;\\s*)${KEY}=(\\d+)`));
    return m ? Number(m[1]) : 0;
  } catch { return 0; }
}

// À appeler une fois le boot réellement terminé, sinon les lancements
// suivants (sans rechargement dur) démarreraient artificiellement haut.
export function clearBootPct() {
  try { document.cookie = `${KEY}=; path=/; max-age=0`; } catch {}
}
